module.exports = __webpack_public_path__ + "assets/img/18e0-fm.svg";